var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-tab-pane", { attrs: { name: "payments" } }, [
    _c("div", { staticClass: "row gutter-x-md justify-start" }, [
      _c("div", { staticClass: "col-md-3 col-12" }, [
        _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
          _vm._v(_vm._s(_vm.$t("payment_deadline")))
        ]),
        _c("p", { staticClass: "text-faded" }, [
          _vm._v(_vm._s(_vm.$t("payment_deadline_hint")))
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-md-9 col-12" },
        [
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.errors.has("defaultPaymentDeadline"),
                "error-label": _vm.errors.first("defaultPaymentDeadline")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|numeric|min:0",
                    expression: "'required|numeric|min:0'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "defaultPaymentDeadline",
                  placeholder: _vm.$t("payment_deadline")
                },
                model: {
                  value: _vm.formData.defaultPaymentDeadline,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "defaultPaymentDeadline", $$v)
                  },
                  expression: "formData.defaultPaymentDeadline"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row gutter-x-md justify-start" }, [
      _c("div", { staticClass: "col-md-3 col-12" }, [
        _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
          _vm._v(_vm._s(_vm.$t("quote_deadline")))
        ]),
        _c("p", { staticClass: "text-faded" }, [
          _vm._v(_vm._s(_vm.$t("quote_deadline_hint")))
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-md-9 col-12" },
        [
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.errors.has("defaultQuoteDeadline"),
                "error-label": _vm.errors.first("defaultQuoteDeadline")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|numeric|min:0",
                    expression: "'required|numeric|min:0'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "defaultQuoteDeadline",
                  placeholder: _vm.$t("quote_deadline")
                },
                model: {
                  value: _vm.formData.defaultQuoteDeadline,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "defaultQuoteDeadline", $$v)
                  },
                  expression: "formData.defaultQuoteDeadline"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "row justify-end" },
      [
        _c(
          "q-btn",
          {
            attrs: { type: "submit", color: "primary" },
            on: { click: _vm.handleSave }
          },
          [_vm._v(_vm._s(_vm.$t("save")))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }